import React, { useState, useEffect } from 'react';

export default function Calander({ kanbanData, onDateClick }) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [calendarDays, setCalendarDays] = useState([]);

  const getCalendarDays = (date) => {
    const start = new Date(date.getFullYear(), date.getMonth(), 1);
    const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const startDay = start.getDay();

    const days = [];

    for (let i = 0; i < startDay; i++) {
      days.push({ date: null, tasks: [] });
    }

    for (let i = 1; i <= end.getDate(); i++) {
      const day = new Date(date.getFullYear(), date.getMonth(), i);
      const dateStr = day.toDateString();

      const tasks = Object.values(kanbanData || {}).flat().filter((task) => {
        const taskDateStr = new Date(task.date).toDateString();
        return taskDateStr === dateStr;
      });

      days.push({
        date: day,
        isToday: day.toDateString() === new Date().toDateString(),
        tasks,
      });
    }

    return days;
  };

  useEffect(() => {
    setCalendarDays(getCalendarDays(currentDate));
  }, [currentDate, kanbanData]);

  const changeMonth = (offset) => {
    const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + offset, 1);
    setCurrentDate(newDate);
  };

  return (
    <div className="bg-white border rounded shadow-sm p-4 mt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <button className="btn btn-sm btn-outline-secondary" onClick={() => changeMonth(-1)}>‹</button>
        <h5 className="mb-0">{currentDate.toLocaleString('default', { month: 'long', year: 'numeric' })}</h5>
        <button className="btn btn-sm btn-outline-secondary" onClick={() => changeMonth(1)}>›</button>
      </div>

      <div className="row text-center fw-bold border-bottom pb-2 mb-2">
        {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map((day, index) => (
          <div key={index} className="col">{day}</div>
        ))}
      </div>

      <div className="row text-center flex-wrap">
        {calendarDays.map((obj, i) => (
          <div key={i} className="col mb-3" style={{ maxWidth: '14.28%' }}>
  {obj.date ? (
    <div
      className={`position-relative d-flex flex-column align-items-center justify-content-center`}
      title={
        obj.tasks.length > 0
          ? obj.tasks.map((task) => `• ${task.title}`).join('\n')
          : ''
      }
      onClick={() => onDateClick?.(obj.date)}
      style={{
        width: '40px',
        height: '40px',
        margin: 'auto',
        borderRadius: '50%',
        backgroundColor: obj.isToday
          ? '#0d6efd'
          : 'transparent',
        color: obj.isToday ? '#fff' : '#000',
        fontWeight: obj.isToday ? 'bold' : 'normal',
        border: obj.tasks.length > 0 ? '2px solid #ffc107' : '1px solid #dee2e6',
        cursor: 'pointer',
        position: 'relative'
      }}
    >
      {obj.date.getDate()}

      {/* Yellow Dot Indicator */}
      {obj.tasks.length > 0 && !obj.isToday && (
        <span
          style={{
            width: '8px',
            height: '8px',
            backgroundColor: '#ffc107',
            borderRadius: '50%',
            position: 'absolute',
            bottom: '4px',
            right: '4px',
          }}
        />
      )}
    </div>
  ) : (
    <div style={{ height: '40px' }}></div>
  )}
</div>

        ))}
      </div>
    </div>
  );
}
